import { gql, TypedDocumentNode } from '@apollo/client';

import { JobBoardDto, QueryGetJobPositionRelatedJobsArgs } from '@pflegia/data-access';

import { JOB_POSITION_FOR_CANDIDATE_FRAGMENT } from '../fragments/job-position-for-candidate';

export const GET_POSITION_RELATED_JOB_LIST: TypedDocumentNode<{ jobPositionsData: JobBoardDto }, QueryGetJobPositionRelatedJobsArgs> = gql`
  query getJobPositionRelatedJobs(
    $sortField: String!
    $sortOrder: String
    $page: Int!
    $perPage: Int!
    $filters: PositionRelatedJobsFilterInput!
  ) {
    jobPositionsData: getJobPositionRelatedJobs(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filters: $filters
    ) {
      jobPositions {
        ...JobPositionForCandidate
        recommended
      }
      total
    }
  }
  ${JOB_POSITION_FOR_CANDIDATE_FRAGMENT}
`;
